export const simulatorNicknamePlaceholder = '{nickname}';

export function buildSimulatorUrl(baseUrl, nickname) {
    const url = new URL(baseUrl);
    const name = nickname?.trim();

    for (const [key, value] of [...url.searchParams]) {
        if (!value.includes(simulatorNicknamePlaceholder)) {
            continue;
        }

        if (name) {
            url.searchParams.set(key, value.replaceAll(simulatorNicknamePlaceholder, name));
        }
        else {
            url.searchParams.delete(key);
        }
    }

    return url.toString();
}
